import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import PlaySongs from "./PlaySongs";
import axios from '../tokenInterceptor';

class Playlists extends Component {
    constructor(props) {
        super(props);
        this.state={
            itemDescriptions:{
                "browse_filter_genres_0_desc":{
                    "itemLabel":""
                },
                "browse_filter_genres_1_desc":{
                    "itemLabel":""
                },
                "browse_filter_moods_7_desc":{
                    "itemLabel":""
                }
            },
            hide:false,
            alternativeRock:{
                "playlist_0_desc":{
                    "image":{
                    }
                }
            },
            bluesSongs :{
                "playlist_0_desc":{
                    "image":{
                    }
                }
            },
            workoutSongs :{
                "playlist_0_desc":{
                    "image":{
                    }
                }
            },
            alternativeRockSubSongs:[],
            selectedMusic:{},
            bluesSubSongs:[],
            workoutSubSongs:[]
        }
    }

    componentWillMount =()=>{
        this.checkTokenExpire();
    }

    getPlaylists=()=>{
        axios.get("/getPlaylists").then((res)=>{
            if(res.data.status == 200) {
                this.getAlternativeRock();
                this.getBluesSongs();
                this.setState({itemDescriptions:res.data.data.itemDescriptions, hide:true});
            } else {
                this.setState({itemDescriptions:{}})
            }
        })
    }

    getAlternativeRock=()=>{
        axios.get("/getAlternativeRocks").then((res)=>{
            if(res.data.status == 200) {
                var alternativeRock = this.state.alternativeRock;
                alternativeRock = res.data.data.itemDescriptions;
                this.setState({alternativeRock:alternativeRock});
                this.getAlternativeRocksSubSongs();
            } else {
                this.setState({alternativeRock:{}})
            }
        })
    }

    getAlternativeRocksSubSongs=()=>{
        axios.get("/getAlternativeRocksSubSongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let alternativeRockSubSongsContent=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                alternativeRockSubSongsContent.push(data);
                };
                this.setState({alternativeRockSubSongs:alternativeRockSubSongsContent});
            } else {
                this.setState({alternativeRockSubSongs:[]})
            }
        })
    }

    getBluesSongs=()=>{
        axios.get("/getBluesSongs").then((res)=>{
            if(res.data.status == 200) {
                var bluesSongs = this.state.bluesSongs;
                bluesSongs = res.data.data.itemDescriptions;
                this.setState({bluesSongs:bluesSongs});
                this.getBluesSubSongs();
            } else {
                this.setState({bluesSongs:{}})
            }
        })
    }

    getBluesSubSongs=()=>{
        axios.get("/getBluesSubSongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let bluesSubSongsContent=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                bluesSubSongsContent.push(data);
                };
                this.setState({bluesSubSongs:bluesSubSongsContent});
            } else {
                this.setState({bluesSubSongs:[]})
            }
        })
    }

    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.title;
        selectedMusic.artist = data.artist.name;
        selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getPlaylists();
            } else {
                console.log("unable t generate token");
            }
        });
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            this.getPlaylists();
        } else {
            this.generateNewAccessToken();
        }
    }

    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        <div className="top-alternative">
                            <h3 className="heading">{this.state.itemDescriptions.browse_filter_genres_0_desc.itemLabel}</h3>
                            <hr/>
                            <ul>
                                <li className="song-title">
                                    <img src={this.state.alternativeRock.playlist_0_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                    <a className="title">{this.state.alternativeRock.playlist_0_desc.itemLabel}</a>
                                </li>
                                <ul>
                                    {this.state.alternativeRockSubSongs.map((data, index)=>{
                                        return <li key={index} className="song-title">
                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                        </li>
                                    })}
                                </ul>
                            </ul>
                        </div>
                        <div className="top-alternative">
                            <h3 className="heading">{this.state.itemDescriptions.browse_filter_genres_1_desc.itemLabel}</h3>
                            <hr/>
                            <ul>
                                <li className="song-title">
                                    <img src={this.state.bluesSongs.playlist_0_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                    <a className="title">{this.state.bluesSongs.playlist_0_desc.itemLabel}</a>
                                </li>
                                <ul>
                                    {this.state.bluesSubSongs.map((data, index)=>{
                                        return <li key={index} className="song-title">
                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                        </li>
                                    })}
                                </ul>
                            </ul>
                        </div>
                        <PlaySongs
                            music={this.state.selectedMusic}
                        /> 
                    </div> 
                </div>
            </>
        )
    }
}

export default Playlists;
